const EVAL_LABELS: Record<string, string> = {
  inbasket: "In-Basket",
  "form:autodiag": "Autodiagnostic",
  "form:egogramme": "Egogramme",
  form: "Questionnaire",
  "ent-struct": "Entretien structuré",
};

export function getEvalLabel(typeEval: string, template?: string): string {
  if (typeEval === "form" && template) {
    return EVAL_LABELS[`form:${template}`] ?? "Questionnaire";
  }
  return EVAL_LABELS[typeEval] ?? typeEval;
}

export function buildParcoursDescription(
  evals: { typeEval: string; template?: string }[],
): string {
  return evals.map((e) => getEvalLabel(e.typeEval, e.template)).join(" • ");
}
